import {
  PhoneVerificationRequestCodeBody,
  PhoneVerificationRequestCodeResult,
  PhoneVerificationVerifyCodeBody,
  PhoneVerificationVerifyCodeResult
} from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

/**
 * Snowy phone verification — INTERNAL surface used by the bot's `verify_phone`
 * tool (ENG-3190). Same service the widget Account tab reaches through its
 * public `/widget-account/code/*` routes.
 */
export class PhoneVerificationAPI {
  static async requestCode(orgId: number, userId: number, body: PhoneVerificationRequestCodeBody) {
    return APIService.Server.post<PhoneVerificationRequestCodeResult>(`/phone-verification/org/${orgId}/user/${userId}/request`, body);
  }

  static async verifyCode(orgId: number, userId: number, body: PhoneVerificationVerifyCodeBody) {
    return APIService.Server.post<PhoneVerificationVerifyCodeResult>(`/phone-verification/org/${orgId}/user/${userId}/verify`, body);
  }
}
